import React from 'react'
import avatar404 from '../../../assets/img/errors/500/Illustration-2.svg'
import error404 from '../../../assets/img/errors/500/500.svg'
import { Row, Col } from 'react-bootstrap'

const Error500: React.FC = () => {
  return (
    <div className="d-flex min-vh-100 align-items-center justify-content-center">
      <Row>
        <Col>
          <div>
            <img src={error404} />
          </div>
          <div className="fw-bold fs-6 my-2">Ups! Error Inesperado</div>
          <div className="mb-2">
            En unos minutos regresa la música, estamos <br /> afinando los instrumentos.
          </div>
          <a href="/" className="btn btn-primary">
            Volver al inicio
          </a>
        </Col>

        <Col>
          <div className="container text-center">
            <img src={avatar404} />
          </div>
        </Col>
      </Row>
    </div>
  )
}

export default Error500
